var map = {
  "./": "87070",
  "./destroy": "54684",
  "./destroy.js": "54684",
  "./index": "87070",
  "./index.js": "87070",
  "./manage": "62279",
  "./manage.js": "62279",
  "./show": "83821",
  "./show.js": "83821"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 22402;
